import axios from "axios";

type ApiErrorData = {
  error?: string;
  message?: string;
  code?: string;
  [key: string]: unknown;
};

export const getApiErrorMessage = (error: unknown, fallback: string) => {
  if (!axios.isAxiosError(error)) return fallback;

  const status = error.response?.status;
  const data = error.response?.data as ApiErrorData | undefined;

  if (data?.message && typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (data?.error && typeof data.error === "string" && data.error.trim()) {
    return data.error;
  }

  if (status === 404) return "Пользователь не найден";
  if (status === 401) return "Неверный логин или пароль";
  if (status === 403) return "Доступ запрещен";
  if (status === 500) return "Внутренняя ошибка сервера";
  if (status === 502) return "Сервер временно недоступен";

  return fallback;
};

export const getApiErrorData = (error: unknown): ApiErrorData | undefined => {
  if (!axios.isAxiosError(error)) return undefined;
  return error.response?.data as ApiErrorData | undefined;
};
